import React, { useEffect, useMemo, useRef, useState } from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';
import moment from 'moment';

import CreateCaseModel from '../../models/CreateCaseModel';
import EditFields from '../common/EditFields';

const useStyles = makeStyles((theme) => {
  return {
    field: {
      margin: '8px 0 12px',
    },
    fieldDescription: {
      marginTop: '16px',
    },
    fieldPaddingLeft: {
      paddingLeft: '0px',
      [theme.breakpoints.up('md')]: {
        paddingLeft: '18px',
      },
    },
    fieldPaddingRight: {
      paddingRight: '0px',
      [theme.breakpoints.up('md')]: {
        paddingRight: '18px',
      },
    },
    labels: {
      marginBottom: '0px',
    },
    link: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
  };
});

export default ({ onOpenDatePopup, onChangeFormStatus, status }) => {
  const [formStatus, setFormStatus] = useState(status);
  const classes = useStyles();
  const nameRef = useRef();
  const genderRef = useRef();
  const telephoneRef = useRef();
  const dateOfBirthRef = useRef();
  const dateRef = useRef();
  const nameField = useMemo(
    () => [
      {
        containerClass: classes.field,
        label: 'Preferred Name',
        name: 'preferredName',
        onChange: (value, isValid) => {
          onChangeFormStatus(value, 'preferredName', isValid);
        },
        placeholder: 'Preferred Name',
        type: 'text',
        variant: 'standard',
      },
    ],
    []
  );
  const genderField = useMemo(
    () => [
      {
        containerClass: classes.field,
        items: [
          { label: 'Female', value: 'female' },
          { label: 'Male', value: 'male' },
          { label: 'Other', value: 'other' },
        ],
        label: 'Gender',
        labelPosition: 'top',
        name: 'gender',
        onChange: (value, isValid) => {
          onChangeFormStatus(value.gender, 'gender', isValid);
        },
        placeholder: 'Select',
        type: 'select',
        variant: 'standard',
      },
    ],
    []
  );
  const telephoneField = useMemo(
    () => [
      {
        containerClass: classes.field,
        label: 'Telephone',
        labelPosition: 'top',
        name: 'phoneNumber',
        onChange: (value, isValid) => {
          onChangeFormStatus(value, 'phoneNumber', isValid);
        },
        placeholder: '+27828501512',
        type: 'phone',
        variant: 'standard',
      },
    ],
    []
  );
  const dateOfBirthField = useMemo(
    () => [
      {
        containerClass: classes.field,
        label: 'Date of Birth',
        labelPosition: 'top',
        name: 'dateOfBirth',
        onChange: (value, isValid) => {
          onChangeFormStatus(value, 'dateOfBirth', isValid);
        },
        placeholder: 'MM/DD/YYYY',
        type: 'date',
        variant: 'standard',
      },
    ],
    []
  );
  const dateField = useMemo(
    () => [
      {
        disabled: true,
        label: 'Estimated Report Delivery',
        name: 'reportDate',
        onChange: (value, isValid) => {
          onChangeFormStatus(value, 'reportDate', isValid);
        },
        type: 'date',
        variant: 'standard',
      },
    ],
    []
  );

  useEffect(() => {
    setFormStatus(status);
  }, [status]);

  const reportDate = moment().add(73, 'hours');
  if (reportDate.day() === 0) reportDate.add(1, 'day');
  else if (reportDate.day() === 6) reportDate.add(2, 'days');
  formStatus.formStatus.reportDate = reportDate.toDate();

  return (
    <Grid container>
      <Grid item xs={12} className={classes.fieldPaddingRight}>
        <EditFields
          validate={CreateCaseModel.validateRequestReport}
          data={formStatus.formStatus}
          labelClass={classes.labels}
          labelPosition="top"
          ref={nameRef}
          fields={nameField}
        />
        <Typography variant="body1" className={`body-copy ${classes.fieldDescription}`} align="left">
          How would you prefer to be addressed?
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.fieldPaddingRight}>
        <EditFields
          validate={CreateCaseModel.validateRequestReport}
          data={formStatus.formStatus}
          labelClass={classes.labels}
          labelPosition="top"
          ref={genderRef}
          fields={genderField}
        />
      </Grid>
      <Grid item xs={12} className={classes.fieldPaddingRight}>
        <EditFields
          validate={CreateCaseModel.validateRequestReport}
          data={formStatus.formStatus}
          labelClass={classes.labels}
          labelPosition="top"
          ref={telephoneRef}
          fields={telephoneField}
        />
      </Grid>
      <Grid item xs={12} className={classes.fieldPaddingRight}>
        <EditFields
          validate={CreateCaseModel.validateRequestReport}
          data={formStatus.formStatus}
          labelClass={classes.labels}
          labelPosition="top"
          ref={dateOfBirthRef}
          fields={dateOfBirthField}
        />
      </Grid>
    </Grid>
  );
};
